import { render, staticRenderFns } from "./GiacenzeMagazzino.vue?vue&type=template&id=4c517e2d&"
import script from "./GiacenzeMagazzino.vue?vue&type=script&lang=js&"
export * from "./GiacenzeMagazzino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports